
import Vue from "vue";
//import BGItem from "../components/BGItem.vue";
import DynamicImage from "../components/DynamicImage.vue";
import { data, T } from "../App.vue";
import AudioClip from "../components/AudioClip.vue";

export default Vue.extend({
  name: "CoinFlip",
  components: {
    DynamicImage,
    AudioClip,
  },

  created() {
    //Randomise the flip result
    data.SeaLevelRise = Math.floor(Math.random() * 2) + 1;
  },

  computed: {
    CoinResultText: {
      get(): string {
        return T("Flip_Coin_" + this.SeaLevelRise);
      },
    },
    SeaLevelRise: {
      get(): number {
        return data.SeaLevelRise;
      },
      set(value: number): void {
        data.SeaLevelRise = value;
      },
    },
    coinId: {
      get(): string {
        return "coin-" + this.SeaLevelRise;
      },
    },
  },
  data() {
    return {
      flipState: 0,
    };
  },
  methods: {
    T(id: string): string {
      return T(id);
    },
    flip(): void {
      this.flipState = 1;
      setTimeout(this.flipFinished, 2000);
    },
    flipFinished(): void {
      this.flipState = 2;
    },
  },
});
